import { BaseModel } from './base.model';

export class DepartamentModel extends BaseModel {

    name: string;

    // emails: any[];
    // department_mail: any[];

    static validate(departament: DepartamentModel): boolean {
        return !!(departament.name);
    }

    constructor(departament?: DepartamentModel) {
        super();

        this.name = departament ? departament.name || null : null;

        // this.emails = departament ? departament.emails || [] : [];
        // this.department_mail = departament ? departament.department_mail || [] : [];
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/departament.model.ts